import { EpimsBaseEntityDto } from './epim-base.dto';

export class AccountableFunctionLink2Dto extends EpimsBaseEntityDto{
  AutoFunctionId: string;
  AutoSerialId: string;
  AccountableFunctionName: string;
  FunctionName: string;
  FunctionalEmail: string;
  SubscriberId: string;
  SubscriptionUserId: string;
}
